// @flow

import React, { Component, type Node } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import moment from 'moment'
// $FlowFixMe
import Select from 'react-select'
// $FlowFixMe
import { Div, Span } from 'react-select/lib/primitives'
// $FlowFixMe
import { components as SelectComponents } from 'react-select'

import { ArrowLeft, ArrowRight } from 'src/components/Icons'

import { createMonthOptions, createDayOptions, getOptionStyles, styles } from './helpers'

const StyledButton = styled.button`
  outline: none;
  background-color: transparent;
  -webkit-appearance: none;
`

const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const defaultOptions = []

defaultOptions.push(createMonthOptions())

type InnerProps = {}

type HeadingProps = {}

type Props = {
  Heading: Object,
  getStyles: Function,
  children?: Node,
  label: string,
  innerProps: InnerProps,
  selectProps: { previous: Function, next: Function, calendarView: string },
  headingProps: HeadingProps,
  cx: string
}

const Group = (props: Props) => {
  const {
    Heading,
    getStyles,
    children,
    label,
    innerProps,
    selectProps: { previous, next, calendarView },
    headingProps,
    cx
  } = props
  return (
    <Div aria-label={label} css={getStyles('group', props)} {...innerProps}>
      <Heading getStyles={getStyles} cx={cx} {...headingProps}>
        <Div css={styles.headingStyles}>
          <StyledButton onClick={previous} type="button">
            <ArrowLeft />
          </StyledButton>
          <Div css={styles.titleStyles}>{label}</Div>
          <StyledButton onClick={next} type="button">
            <ArrowRight />
          </StyledButton>
        </Div>
      </Heading>
      {calendarView === 'days' && (
        <Div css={styles.daysHeaderStyles}>
          {days.map((day, i) => (
            <Span key={`${i}-${day}`} css={styles.daysHeaderItemStyles}>
              {day}
            </Span>
          ))}
        </Div>
      )}
      <Div css={styles.daysContainerStyles}>{children}</Div>
    </Div>
  )
}

type OptionProps = {
  data: { displayType: string, display: string, date: moment },
  getStyles: Function,
  innerRef: string,
  innerProps: InnerProps,
  isSelected: boolean,
  isDisabled: boolean,
  isFocused: boolean
}

const Option = (props: OptionProps) => {
  const { data, getStyles, innerRef, innerProps, isSelected, isDisabled, isFocused } = props
  const { displayType } = data
  if (data.display === 'calendar') {
    const defaultStyles = getStyles('option', props)
    const styles = getOptionStyles(defaultStyles, displayType, isDisabled, isSelected, isFocused)
    if (data.date.date() === 1) {
      const indentBy = data.date.day()
      if (indentBy && displayType === 'day') {
        styles.marginLeft = `${indentBy * 14 + 1}%`
      }
    }
    return (
      <Span {...innerProps} css={styles} ref={innerRef}>
        {displayType === 'months' ? data.date.format('MMM') : data.date.format('D')}
      </Span>
    )
  } else return <SelectComponents.Option {...props} />
}

type OptionType = {
  label: string
}

type State = {
  calendarView: string,
  yearsOffset: number,
  monthsOffset: number,
  menuIsOpen: boolean,
  options: Array<OptionType>,
  selectedMonth?: { value: string, label: string }
}

export class SequentialDatePicker extends Component<*, State> {
  wrapperRef: any
  state = {
    calendarView: 'years',
    yearsOffset: 1,
    monthsOffset: 1,
    options: defaultOptions,
    menuIsOpen: false
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, true)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true)
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef = (node: any) => {
    this.wrapperRef = node
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside = (event: any) => {
    // eslint-disable-next-line react/no-find-dom-node
    const domNode = ReactDOM.findDOMNode(this)
    if (this.wrapperRef && domNode && domNode.contains && !domNode.contains(event.target)) {
      this.setState({
        menuIsOpen: false
      })
    }
  }

  handleInternalChange = (value: { value: string, label: string, date: moment }) => {
    const current = moment()
    const actual = moment(value.value)
    const diff = Math.ceil(actual.diff(current, 'months', true))
    const monthsOffset = current.month() === actual.month() ? diff + 1 : diff
    this.setState({
      monthsOffset,
      selectedMonth: value,
      calendarView: 'months',
      menuIsOpen: true,
      options: [createDayOptions(value.date)]
    })
  }

  getOffsetOptions = (offsetType: string, currentOffset: number, offset: number) => {
    const date =
      offset < 0
        ? moment().add(currentOffset - 2, offsetType)
        : moment().add(currentOffset, offsetType)
    const options = offsetType === 'years' ? [createMonthOptions(date)] : [createDayOptions(date)]
    this.setState({
      [`${offsetType}Offset`]: currentOffset + offset,
      options
    })
  }

  render() {
    const { calendarView, yearsOffset, monthsOffset, options, menuIsOpen } = this.state
    const currentOffset = calendarView === 'years' ? yearsOffset : monthsOffset
    return (
      <Select
        {...this.props}
        components={{ Group, Option }}
        options={options}
        ref={this.setWrapperRef}
        previous={() => this.getOffsetOptions(calendarView, currentOffset, -1)}
        next={() => this.getOffsetOptions(calendarView, currentOffset, 1)}
        onChange={e => {
          if (calendarView === 'years') {
            this.handleInternalChange(e)
          } else {
            this.setState({ menuIsOpen: false })
            this.props.onChange(e)
          }
        }}
        calendarView={calendarView}
        onFocus={() => this.setState({ menuIsOpen: true })}
        menuIsOpen={menuIsOpen}
        onMenuClose={() =>
          calendarView === 'months' &&
          this.setState({
            calendarView: 'years',
            options: defaultOptions,
            yearsOffset: 1,
            monthsOffset: 1
          })
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SequentialDatePicker/index.js